import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  draft: { label: "Draft", cls: "bg-muted text-muted-foreground" },
  submitted: { label: "Submitted", cls: "bg-accent/15 text-accent" },
  under_review: { label: "Under review", cls: "bg-accent/15 text-accent" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-800" },
  new: { label: "New", cls: "bg-accent/15 text-accent" },
  in_review: { label: "In review", cls: "bg-amber-100 text-amber-800" },
  quoted: { label: "Quoted", cls: "bg-primary/15 text-primary" },
  closed: { label: "Closed", cls: "bg-muted text-muted-foreground" },
  preparing: { label: "Preparing", cls: "bg-amber-100 text-amber-800" },
  in_transit: { label: "In transit", cls: "bg-accent/15 text-accent" },
  customs: { label: "Customs", cls: "bg-primary/15 text-primary" },
  delivered: { label: "Delivered", cls: "bg-emerald-100 text-emerald-800" },
  delayed: { label: "Delayed", cls: "bg-red-100 text-red-700" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || { label: status, cls: "bg-muted text-muted-foreground" };
  return <Badge className={`${s.cls} capitalize border-transparent`} data-testid={`status-${status}`}>{s.label}</Badge>;
}
